import { Reducer } from 'redux'
import { DoctorState, DoctorActionTypes } from './type'

const initialState: DoctorState = {
  list: {
    totalPage: 0,
    currentPage: 0,
    data: []
  },
  detail: {},
  evaluate: {
    rating: 0,
    totalItem: 0,
    tags: [],
    totalPage: 0,
    currentPage: 0,
    data: [],
    systemEvaluateNum: 0,
  },
  recommand: [],
  mine: [],
}

const reducer: Reducer<DoctorState> = (state = initialState, action) => {
  switch (action.type) {
    case DoctorActionTypes.FETCH_DOCTOR_LIST_PAGE_SUCCESS: {
      const { data, currentPage, totalPage } = action;
      if (currentPage === 1) {
        return {
          ...state,
          list: {
            data,
            totalPage,
            currentPage
          }
        }
      }
      return {
        ...state, list: {
          data: [...state.list.data, ...data],
          totalPage,
          currentPage
        }
      }
    }
    case DoctorActionTypes.FETCH_DOCTOR_LIST_SUCCESS: {
      const { data } = action;
      return {
        ...state, list: {
          data,
          totalPage: 1,
          currentPage: 1,
        }
      }
    }
    case DoctorActionTypes.FETCH_DOCTOR_DETAIL_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        detail: data
      }
    }
    case DoctorActionTypes.CLEAR_DOCTOR_DETAIL: {
      return {
        ...state,
        detail: {}
      }
    }
    case DoctorActionTypes.FETCH_DOCTOR_RECOMMAND_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        recommand: data
      }
    }
    case DoctorActionTypes.FETCH_DOCTOR_EVALUTE_SUCCESS: {
      const { data, currentPage, totalPage, tags, rating, totalItem, systemEvaluateNum } = action;
      if (currentPage === 1) {
        return {
          ...state,
          evaluate: {
            data,
            totalPage,
            currentPage,
            tags,
            rating,
            totalItem,
            systemEvaluateNum
          }
        }
      }
      return {
        ...state, 
        evaluate: {
          data: [...state.evaluate.data, ...data],
          totalPage,
          currentPage,
          tags,
          rating,
          totalItem,
          systemEvaluateNum
        }
      }
    }
    case DoctorActionTypes.INIT_MY_DOCTOR_SUCCESS: {
      const { data, patientId } = action;
      return {
        ...state,
        mine: {
          ...state.mine,
          [`${patientId}`]: data,
        }
      }
    }
    case DoctorActionTypes.FETCH_MY_DOCTOR_SUCCESS: {
      const { data, patientId } = action;
      return {
        ...state,
        mine: {
          ...state.mine,
          [`${patientId}`]: data,
        }
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as DoctorReducer };